<fhm-page [title]="'fhm.' + type + '.title'" [showColumnSearch]="showColumnSearch"
  (nameSearchChanged)="nameSearchChanged($event)"
  (serviceSelection)="serviceSelection.emit($event)">

  <ng-content select=".searchControls" ngProjectAs=".searchControls"></ng-content>

  @if (showAdd || showRefresh) {
    <div class="dashboard-header">
      @if (showRefresh) {
        <fui-action (click)="refreshData()" [attr.title]="'wbo.common.button.refresh' | translate">
          <fui-icon [height]="20" [icon]="'refresh'" [width]="20" class="utility-refresh-icon"></fui-icon>
        </fui-action>
      }
      @if (showAdd) {
        <fui-action-button [title]="'fhm.' + type + '.addNew'" class="utility-add-new"
          (click)="addNew.emit($event)">
          <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
        </fui-action-button>
      }
    </div>
  }
  <fhm-search-grid [records]="gridView"
    [columns]="columns"
    [sortableColumns]="sortableColumns"
    [showLink]="showLink"
    [showDownloadReport]="showDownloadReport"
    [showDelete]="showDelete"
    [showDeleteFunc]="showDeleteFunc"
    [showRecontinueFunc]="showRecontinueFunc"
    [type]="type"
    [styleColumnFn]="styleColumnFn"
    [valueColumnFn]="valueColumnFn"
    (selectRecord)="selectRecord.emit($event)"
    (deleteRecord)="deleteRecord.emit($event)"
    (recontinueRecord)="recontinueRecord.emit($event)"
    (downloadReport)="downloadReport.emit($event)"
    (columnSorted)="columnSorted.emit($event)"
    (linkColumnClicked)="linkColumnClicked.emit($event)">
  </fhm-search-grid>
  @if (paging) {
    <div class="pagination">
      <div class="pagination-controls">
        @if (pageIndex > 0) {
          <fui-link-button [title]="'Previous'" (click)="goToPage(this.pageIndex - 1)"
          class="pagination-controls-previous"></fui-link-button>
        }
        @if (pageIndex < (totalPages - 1)) {
          <fui-link-button [title]="'Next'" (click)="goToPage(this.pageIndex + 1)"
          class="pagination-controls-next"></fui-link-button>
        }
      </div>
      {{pageIndex * pageSize + 1}} - {{totalRecordsOnPage}} of {{totalRecords}} items
    </div>
  }

  <ng-content select=".searchFooter"></ng-content>
</fhm-page>
